import http from './request'

// 开始访问 Seo domain
export const startAccess = (data) => {
  return http({
    url: '/advertCenter/SeoDomainAccess/startAccess',
    method: 'post',
    data
  })
}

// 完成 Seo domain访问
export const finishAccess = (data) => {
  return http({
    url: '/advertCenter/SeoDomainAccess/finishAccess',
    method: 'post',
    data
  })
}
